<script>
  import ResumeCard from "../components/resumeCard.svelte";
  import { resume } from "../utils/resume";
</script>

<main>
  <div class='mt-0 mb-8'>
    <h1 class='text-3xl font-thin text-center '>Resu<span class='font-semibold'>me</span></h1>
  </div>
  <div
    class="flex justify-center md:flex-nowrap flex-wrap items-center md:space-x-4 md:px-0 px-4"
  >
    <div  class="md:max-w-[450px] w-full">
      <h1 class="text-2xl font-semibold px-2">Education</h1>
      {#each resume.education as ed}
        <ResumeCard {...ed} />
      {/each}
    </div>
    <div class="md:max-w-[450px] w-full">
      <h1 class="text-2xl font-semibold px-2">Experience</h1>
      {#each resume.experience as ed}
        <ResumeCard {...ed} />
      {/each}
    </div>
  </div>
</main>
